export const formatCellValue = (value) => {
  if (value instanceof Date) {
    return value.toLocaleDateString('ru-RU');
  }
  if (value === null || value === undefined) {
    return '';
  }
  return value.toString();
};
